import * as swcHelpers from '@swc/helpers';

const createServiceObject = (serviceType = 'WebPage', audience, category, brand)=>swcHelpers.objectSpread({
        '@context': 'https://schema.org',
        '@type': 'Service',
        serviceType
    }, audience && {
        audience
    }, category && {
        category
    }, brand && {
        brand
    })
;
/*
 * Sets the global grandvision.service object.
 * For analytics purposes, be sure to use English values only.
 * Audience, category and brand may be supplied when relevant.
 * */ /**
 * @deprecated - use the Data Layer for analytics
 */ const setServiceObject = (serviceType, audience, category, brand)=>{
    if (typeof window === 'undefined') {
        return;
    }
    if (!window.grandvision) {
        window.grandvision = {};
    }
    window.grandvision.service = createServiceObject(serviceType, audience, category, brand);
};

export { setServiceObject };
//# sourceMappingURL=service.js.map
